// Practice Round — no betting. GolfGamesScorecard has no calc for 'practice';
// its dispatcher (calcGame) falls through to the default calcStroke so there is
// a leader to display, with no payouts. We mirror that exactly: gross totals,
// lowest first, and the panel makes clear there is no wager.
export function calcPractice(players) {
  return (players || [])
    .map((p) => ({ ...p, total: p.scores.reduce((s, v) => s + (v ?? 0), 0) }))
    .sort((a, b) => a.total - b.total)
}
